export default {
	title: 'Collector Definition',
	actions: {
		add: 'Add',
		edit: 'Edit',
		copy: 'Copy',
		delete: 'Delete',
		batchDelete: 'Batch Delete'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete the selected {count} records?',
		deleteSuccess: 'Operation successful',
		selectDeleteWarning: 'Please select records to delete',
		operateSuccess: 'Operation successful',
		getSuccess: 'Get successful',
		sendSuccess: 'Send successful',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty'
	},
	form: {
		terminalNumber: 'Terminal Number',
		configName: 'Config Name',
		selectTerminal: 'Select Terminal',
		config: 'Config',
		placeholder: {
			terminalNumber: 'Please enter terminal number',
			configName: 'Please enter config name',
			selectTerminal: 'Please select terminal',
			config: 'Please select config'
		}
	},
	table: {
		terminalNumber: 'Terminal Number',
		configName: 'Config',
		sleepTimeDisplay: 'Sleep Time',
		specFreqDisplay: 'Spec Freq',
		updateTime: 'Last Update'
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		copy: 'Copy',
		cancel: 'Cancel',
		confirm: 'Confirm',
		terminalInfo: 'Terminal Info',
		selfCheck: 'Terminal Self Check',
		checkInfo: 'Check Info',
		getConfig: 'Get Config',
		check: 'Terminal Self Check'
	},
	widgetForm: {
		name: 'Name',
		gridLayout: 'Grid Layout',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		placeholder: {
			name: 'Please enter name'
		}
	},
	terminal: {
		selectTerminal: 'Select Terminal',
		config: 'Config',
		sleepTime: 'Sleep Time',
		charValue: 'Characteristic Value',
		wave: 'Waveform',
		charValueLength: 'Char Value Sample Length',
		charValueFreq: 'Char Value Sample Freq',
		highAccelLength: 'High Accel Sample Length',
		highAccelFreq: 'High Accel Sample Freq',
		lowAccelLength: 'Low Accel Sample Length',
		lowAccelFreq: 'Low Accel Sample Freq',
		longWaveLength: 'Long Wave Sample Length',
		longWaveFreq: 'Long Wave Sample Freq',
		waveSampleInterval: 'Wave Sample Interval',
		longWaveInterval: 'Long Wave Interval',
		rpmChannel1: 'RPM Channel 1',
		rpmChannel2: 'RPM Channel 2',
		waveChannel: 'Wave Channel',
		channel: 'Channel',
		sensitivity: 'Sensitivity',
		online: 'Online',
		offline: 'Offline',
		normal: 'Normal',
		abnormal: 'Abnormal'
	},
	configSection: {
		config: 'Config',
		sleepConfig: 'Sleep Config',
		charValueConfig: 'Char Value Config',
		waveConfig: 'Wave Config',
		channelConfig: 'Channel Config',
		collectLength: 'Collect Length',
		collectFreq: 'Collect Freq',
		highLength: 'High Length',
		highFreq: 'High Freq',
		lowLength: 'Low Length',
		lowFreq: 'Low Freq',
		longLength: 'Long Length',
		longFreq: 'Long Freq',
		waveInterval: 'Wave Interval',
		longWaveInterval: 'Long Wave Interval',
		rpm1Channel: 'RPM 1 Channel',
		rpm2Channel: 'RPM 2 Channel',
		waveChannels: 'Wave Channels'
	},
	timeUnit: {
		second: 's',
		minute: 'min',
		hour: 'h',
		day: 'd',
		s: 's',
		min: 'min',
		h: 'h',
		d: 'd'
	},
	buttons: {
		getConfig: 'Get Config',
		selfCheck: 'Self Check',
		send: 'Send',
		setSensitivity: 'Set Sensitivity',
		getWave: 'Get Wave',
		confirm: 'Confirm',
		cancel: 'Cancel'
	},
	options: {
		sleep: 'Sleep Time',
		spec: 'Characteristic Value',
		wave: 'Waveform',
		sleep_time: 'Sleep Time',
		spec_length: 'Char Value Sample Length',
		spec_freq: 'Char Value Sample Freq',
		high_length: 'High Accel Sample Length',
		high_freq: 'High Accel Sample Freq',
		low_length: 'Low Accel Sample Length',
		low_freq: 'Low Accel Sample Freq',
		long_length: 'Long Wave Sample Length',
		long_freq: 'Long Wave Sample Freq',
		wave_time: 'Wave Sample Interval',
		long_wave_time: 'Long Wave Interval',
		rpm1: 'RPM Channel 1',
		rpm2: 'RPM Channel 2',
		channels: 'Wave Channel',
		timeOptions: {
			'10s': '10s',
			'20s': '20s',
			'30s': '30s',
			'1min': '1min',
			'5min': '5min',
			'10min': '10min',
			'20min': '20min',
			'30min': '30min',
			'1h': '1h',
			'2h': '2h',
			'4h': '4h',
			'6h': '6h',
			'12h': '12h',
			'1d': '1d',
			'2d': '2d',
			'3d': '3d',
			'4d': '4d'
		},
		lengthOptions: {
			'1K': '1K',
			'2K': '2K',
			'4K': '4K',
			'8K': '8K',
			'16K': '16K',
			'32K': '32K',
			'64K': '64K',
			'128K': '128K',
			'256K': '256K',
			'512K': '512K',
			'2048K': '2048K'
		},
		freqOptions: {
			'2560': '2560',
			'5120': '5120',
			'12800': '12800',
			'25600': '25600',
			'51200': '51200'
		}
	}
}
